export default __webpack_public_path__ + "static/media/shield3.1426a2d9.png";